import DatePicker from "../../../../Forms/DatePicker/DatePicker";

interface Props {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}

const DateFilterField: React.FC<Props> = ({ name, label, value, onChange }) => (
  <DatePicker
    label={label}
    name={name}
    value={value}
    onChange={(date) => onChange(date)}
    placeholder="Seleccione una fecha"
    iconKey="calendar"
  />
);

export default DateFilterField;
